var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconTutorGamesLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .tutorline {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "tutorline",
    d: "M42.25,22.45c0-2.24-1.83-4.08-4.08-4.08h0c-.94,0-1.81.33-2.5.87-.6-1.5-2.07-2.57-3.78-2.57-1.05,0-2.01.41-2.73,1.07-.7-1.24-2.03-2.08-3.55-2.08-.61,0-1.18.14-1.7.38v-7.72c0-2.12-1.56-3.98-3.67-4.18-2.42-.24-4.48,1.68-4.48,4.06v16.49s-3.04-3.04-3.04-3.04c-1.5-1.5-3.92-1.71-5.55-.36-1.88,1.54-1.98,4.36-.3,6.04l4.92,4.92c2.54,2.54,3.97,5.99,3.97,9.59h0c0,2.24,1.83,4.08,4.08,4.08h15.29c2.24,0,4.08-1.83,4.08-4.08v-2.73c.05-.12.09-.23.12-.36l.49-1.35c1.39-3.81,2.22-7.81,2.44-11.87h0s-.06,0-.06,0c.04-.22.06-.45.06-.68v-2.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconTutorGamesLine);
export default __webpack_public_path__ + "static/media/cloud_icon_tutor_games_line.8b45494d39311643167ff5fd89d077cc.svg";
export { ForwardRef as ReactComponent };